import React, { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { PurchaseEligibilityStatus } from 'src/api/@generated/backend';

import { Breadcrumb } from 'src/components/breadcrumb';
import { ProtectedOrderRoute } from 'src/components/protected-order-route/protected-order-route';
import { ProductDetails } from 'src/pages/product-details';
import { PageProductSelect } from 'src/pages/product-select';
import { PageSuccess } from 'src/pages/success';
import { SummaryPage } from 'src/pages/summary/summary';
import { NavigationService } from 'src/services/navigation-service';
import { selectPurchaseEligibilityStatus } from 'src/state/request/selectors';
import { RequestType } from 'src/state/request/types';
import { selectSelectedProductOrThrow } from 'src/state/order/selectors';

export const Store: FC = () => (
  <>
    <Breadcrumb />
    <Routes>
      <Route
        element={
          <ProtectedOrderRoute
            requests={[RequestType.GET_PRODUCTS_WITH_ELIGIBILITY]}
            guards={[
              {
                isProtected: (state) => selectPurchaseEligibilityStatus(state) === PurchaseEligibilityStatus.USER_ROLE,
                redirectTo: NavigationService.ERROR_WRONG_ROLE,
              },
              {
                isProtected: (state) =>
                  selectPurchaseEligibilityStatus(state) === PurchaseEligibilityStatus.PURCHASE_RESTRICTION,
                redirectTo: NavigationService.ERROR_RESTRICTED_PURCHASE,
              },
              {
                isProtected: (state) => selectPurchaseEligibilityStatus(state) === PurchaseEligibilityStatus.OPEN_ORDER,
                redirectTo: NavigationService.ERROR_HAS_INFLIGHT_ORDER,
              },
              {
                isProtected: (state) => {
                  const status = selectPurchaseEligibilityStatus(state);

                  return status !== PurchaseEligibilityStatus.SUCCESS && status !== PurchaseEligibilityStatus.DUNNING;
                },
                redirectTo: NavigationService.ERROR,
              },
            ]}
          />
        }
      >
        <Route path={NavigationService.STORE} element={<PageProductSelect />} />
      </Route>
      <Route
        element={
          <ProtectedOrderRoute
            guards={[
              {
                isProtected: (state) => !selectSelectedProductOrThrow(state).purchaseStatus.eligibleToPurchase,
                redirectTo: NavigationService.STORE,
              },
            ]}
          />
        }
      >
        <Route path={NavigationService.PRODUCT_DETAILS} element={<ProductDetails />} />
      </Route>
      <Route element={<ProtectedOrderRoute />}>
        <Route path={NavigationService.SUMMARY} element={<SummaryPage />} />
        <Route path={NavigationService.SUCCESS} element={<PageSuccess />} />
      </Route>
      <Route path="*" element={<Navigate to={NavigationService.CHOOSE_ACCOUNT} replace={true} />} />
    </Routes>
  </>
);
